<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/11GQpLd/tc-custom/9781595585769.jpg?1737196543580" alt="This image is the cover for the book Hope Dies Last"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Hope Dies Last
      </h1>
      <p class="bookDescription body article font2">
        <b>America’s most inspirational voices, in their own words: “If you’re looking for a reason to act and dream again, you’ll find it in the pages of this book” (<i>Chicago Tribune</i>).</b><br/>  <br/> Published when Studs Terkel was ninety-one years old, this astonishing oral history tackles one of the famed journalist’s most elusive subjects: Hope. Where does it come from? What are its essential qualities? How do we sustain it in the darkest of times? An alternative, more personal chronicle of the “American century,” <i>Hope Dies Last</i> is a testament to the indefatigable spirit that Studs has always embodied, and an inheritance for those who, by taking a stand, are making concrete the dreams of today.<br/>  <br/> A former death row inmate who served nearly twenty years for a crime he did not commit discusses his never-ending fight for justice. Tom Hayden, author of <i>The Port Huron Statement</i>, contemplates the legacy of 1960s student activism. Liberal economist John Kenneth Galbraith reflects on the enduring problem of corporate malfeasance. From a doctor who teaches his young students compassion to the retired brigadier general who flew the <i>Enola Gay</i> over Hiroshima, these interviews tell us much about the power of the American dream and the force of individuals who advocate for a better world. With grace and warmth, Terkel’s subjects express their secret hopes and dreams. Taken together, this collection of interviews tells an inspiring story of optimism and persistence, told in voices that resonate with the eloquence of conviction.<br/>  <br/> “The value of <i>Hope Dies Last</i> lies not in what it teaches readers about its narrow subject, but in the fascinating stories it reveals, and the insight it allows into the vast range of human experience.” —<i>The A.V. Club</i><br/>  <br/> “Very Terkelesque—by now the man requires an adjective of his own.” —Margaret Atwood, <i>The New York Times Review of Books</i><br/>  <br/> “An American treasure.” —Cornel West
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Studs Terkel
      </h2>
      
      <p class="authorDescription body article">Daniel Boyarin, Taubman Professor of Talmudic Culture and rhetoric at the University of California, Berkeley, is the recipient of numerous awards and fellowships. His books include <I>A Radical Jew</I>, <I>Border Lines</I>, and <I>Socrates and the Fat Rabbis</I>. He lives in Berkeley, California.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The New Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?36fa36b7